import { useEffect } from "react";
import { useLocation } from "wouter";

const SCRIPT_SRC = "https://nap5k.com/tag.min.js";
const ZONE_ID = "11657585";
const SCRIPT_SELECTOR = `script[data-nap5k-zone="${ZONE_ID}"]`;

function isPublicContentRoute(pathname: string) {
  return pathname === "/" ||
    pathname === "/news" ||
    pathname.startsWith("/article/") ||
    pathname.startsWith("/clubs/") ||
    pathname === "/highlights" ||
    pathname.startsWith("/matches") ||
    pathname === "/standings";
}

function createScript(position: "head" | "body") {
  const script = document.createElement("script");
  script.src = SCRIPT_SRC;
  script.dataset.zone = ZONE_ID;
  script.dataset.nap5kZone = ZONE_ID;
  script.dataset.nap5kPosition = position;
  script.async = true;
  return script;
}

export default function Nap5kLoader() {
  const [location] = useLocation();

  useEffect(() => {
    if (!isPublicContentRoute(location)) return;
    if (document.querySelector(SCRIPT_SELECTOR)) return;

    let cancelled = false;
    const load = () => {
      if (cancelled || document.querySelector(SCRIPT_SELECTOR)) return;
      const headScript = createScript("head");
      const bodyScript = createScript("body");
      document.head.appendChild(headScript);
      document.body.appendChild(bodyScript);
    };
    const timer = window.setTimeout(load, 2500);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [location]);

  return null;
}

export { isPublicContentRoute };
